//@ts-check
import React, { useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"

import Button from "./button"

export default function ClearAllDialog({ 
  open = false, 
  setOpen, 
  clearFiles, 
  title=undefined,
  contentText=undefined,
  actionButtonText=undefined,
}) {
  const { t } = useTranslation()

  const modalTitle = title ? title : t("clearAllFilesQuestion")
  const modalContentText = contentText ? contentText : t("thisWillDeleteAllCode")
  const modalActionButtonText = actionButtonText ? actionButtonText : t("clearAllFiles")

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const useStyles = makeStyles(theme => ({
    actionsSection: {
      justifyContent: "flex-end",
    },
  }))
  const classes = useStyles({})

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="clear-all-dialog-title"
        aria-describedby="clear-all-dialog-description"
      >
        <DialogTitle id="clear-all-dialog-title">{modalTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="clear-all-dialog-description">
            {modalContentText}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.actionsSection}>
          <Button
            onClick={handleClose}
            variant="outlined"
            color="primary"
          >
            {t("cancel")}
          </Button>
          <Button onClick={() => {
            clearFiles()
            handleClose()
          }} 
          color="primary" autoFocus>
            {modalActionButtonText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>)
}